/**
 * Mapping ModePaiement → icône par enumKey (prioritaire) ou id (fallback).
 * Icône par défaut : bold/money/card.
 */

/** Mode de paiement (id + enumKey optionnel) pour la résolution d'icône */
export type ModePaiementRef = { id: number; enumKey?: string };

/** enumKey (ModePaiement) → icône */
const ENUM_KEY_TO_ICON: Record<string, string> = {
  MODE_PAIEMENT_AMERICAN_EXPRESS: "bold/money/card",
  MODE_PAIEMENT_CB: "bold/money/card",
  MODE_PAIEMENT_VISA: "bold/money/card",
  MODE_PAIEMENT_MASTERCARD: "bold/money/card",
  MODE_PAIEMENT_CHEQUE_VACANCES: "bold/money/ticket",
  MODE_PAIEMENT_TITRE_RESTAURANT: "bold/money/card",
};

/** id (ModePaiement) → icône */
const ID_TO_ICON: Record<number, string> = {
  1265: "bold/money/card",
  1268: "bold/money/card",
  1282: "bold/money/card",
  1278: "bold/money/card",
  1274: "bold/money/ticket",
  1285: "bold/money/card",
  1271: "bold/money/ticket",
  1273: "bold/money/ticket",
  4136: "bold/money/ticket",
  4139: "bold/money/ticket",
  5646: "bold/money/ticket",
  7245: "bold/money/euro",
  1276: "bold/money/ticket",
  1264: "bold/money/card",
  1267: "bold/money/card",
  1270: "bold/money/card",
  1269: "bold/money/card",
  1277: "bold/money/euro",
  5984: "bold/money/card",
  7339: "bold/money/card",
  6510: "bold/money/card",
  6271: "bold/money/card",
  1266: "bold/money/ticket",
  1284: "bold/money/ticket",
  7456: "bold/money/euro",
  6203: "bold/money/ticket",
  6284: "bold/money/card",
  4098: "bold/money/card",
  5408: "bold/money/euro",
  1286: "bold/money/ticket",
  6852: "bold/money/card",
  7171: "bold/money/ticket",
  6367: "bold/money/ticket",
  1272: "bold/money/ticket",
  6181: "bold/money/ticket",
  1275: "bold/money/euro",
  1279: "bold/money/card",
  1280: "bold/money/card",
  5558: "bold/money/card",
  6762: "bold/money/ticket",
  6283: "bold/money/card",
  1287: "bold/money/card",
  5868: "bold/money/card",
  1281: "bold/money/card_send",
  1283: "bold/money/card",
  6461: "bold/money/ticket",
};

const DEFAULT_MODE_PAIEMENT_ICON = "bold/money/card";

/**
 * Retourne l'icône pour un mode de paiement : enumKey en priorité, puis id en fallback.
 */
export function getModePaiementIconName(
  mode: ModePaiementRef | undefined,
): string {
  if (!mode) return DEFAULT_MODE_PAIEMENT_ICON;
  const enumKey = mode.enumKey?.trim() ?? "";
  if (enumKey && ENUM_KEY_TO_ICON[enumKey]) {
    return ENUM_KEY_TO_ICON[enumKey];
  }
  const id = typeof mode.id === "number" ? mode.id : undefined;
  if (id !== undefined && ID_TO_ICON[id] !== undefined) {
    return ID_TO_ICON[id];
  }
  return DEFAULT_MODE_PAIEMENT_ICON;
}
